module.exports = __webpack_public_path__ + "static/img/banner_mobile.871b63a6.png";